import { useLocation } from "react-router-dom";

export default function useLocationStatus() {
  const location = useLocation();
  const isReferral = location.pathname.includes('/referral/');
  const isReferrals = location.pathname.includes("/referrals");
  const isClient = location.pathname.includes('/manageclient/');
  const isClientForm = location.pathname.includes("/clients/");
  const isClients = location.pathname.endsWith("/clients");
  const isProgram = location.pathname.includes('/program/');
  const isPrograms = location.pathname.endsWith("/programs");
  const isLocation = location.pathname.includes('/location/');
  const isLocations = location.pathname.endsWith('/locations');
  const isUserView = location.pathname.includes('/view/') && location.pathname.includes('/users/');
  const isTemplates = location.pathname.includes('/templates');
  const isServices = location.pathname.includes('/services');
  const isLocationPrograms= isLocation && isPrograms;
  const isProgramLocations= isProgram && isLocations;

  return {isLocationPrograms, isProgram, isLocation, isProgramLocations, isPrograms,
          isLocations, isReferral, isReferrals, isClients, isClient, isClientForm, isUserView, isTemplates, isServices};
};